// Curbside / drive-thru display vocabulary.
//
// The mode keys and reason codes are the server's — it decides availability and sends a
// code; the panel only renders it. Keeping the wording here rather than inline in the
// components means the branch settings page and the arrivals queue can never describe the
// same state two different ways.

export const FULFILLMENT_MODES = ["curbside", "drivethru"];

// FULFILLMENT_MODES above are the two configurable modes. `pickup` appears only on
// ARRIVALS — it is the legacy tap from the app that is live today (orderType "Pickup"),
// which has no branch config behind it.
export const MODE_LABELS = {
  curbside: "Curbside",
  drivethru: "Drive-Thru",
  pickup: "Pickup (legacy)",
};

// Why a mode is not orderable right now, keyed by the server's `reason` code.
export const UNAVAILABLE_LABELS = {
  not_offered: "Not offered at this branch",
  paused: "Paused by staff",
  branch_snoozed: "Branch is not accepting online orders",
  branch_inactive: "Branch is inactive",
  closed: "Outside operating hours",
  capacity_full: "At capacity",
};

// Arrival lifecycle, as shown to head office.
export const ARRIVAL_STATUS_LABELS = {
  waiting: "Waiting",
  acknowledged: "Staff on the way",
  handed_over: "Handed over",
  stood_down: "Customer left",
  disputed: "Not found",
};

// Terminal states — nothing further can happen to them, so they get no action buttons.
// Mirrors CLOSED_STATUSES in the API's OrderArrivalController. `disputed` is deliberately
// NOT here: "not found" keeps the car in the queue, and staff must still be able to
// acknowledge or hand over if the customer turns up.
export const CLOSED_ARRIVAL_STATUSES = ["handed_over", "stood_down"];

export const ARRIVAL_STAGE_LABELS = {
  approaching: "On the way",
  arrived: "Here",
};

// Notification dispatch outcome. `no_device` is the one that matters operationally: the
// branch tablet was unreachable, so somebody may be sitting outside unnoticed.
export const NOTIFY_OUTCOME_LABELS = {
  dispatched: "Branch notified",
  no_device: "Branch tablet offline",
  failed: "Notification failed",
};

// Append-only arrival history. The rejected_* entries are the ones that settle a dispute
// over whether the customer actually tapped.
export const ARRIVAL_EVENT_LABELS = {
  approaching: "Said they were on the way",
  arrived: "Announced arrival",
  re_announced: "Announced again",
  acknowledged: "Staff acknowledged",
  handed_over: "Handed over",
  stood_down: "Customer stood down",
  disputed: "Staff could not find them",
  notify_failed: "Branch could not be notified",
  rejected_cooldown: "Tap ignored (too soon after the last one)",
  rejected_out_of_radius: "Tap rejected (outside the area)",
  anpr_matched: "Matched by camera",
};
